import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2, ExternalLink } from 'lucide-react';

export const ConsolidatedPaidBadge = ({ invoiceId, note, testId, compact = false, ratio }) => {
  if (!invoiceId) return null;
  const href = `/consolidated-invoice?id=${invoiceId}`;
  const partial = ratio != null && ratio < 0.999;
  if (compact) {
    return (
      <Link to={href} onClick={(e) => e.stopPropagation()} className={`inline-flex items-center gap-1 mt-1 px-2 py-0.5 rounded-full text-white text-xs font-bold ${partial ? 'bg-amber-500 hover:bg-amber-600' : 'bg-green-600 hover:bg-green-700'}`} data-testid={testId}>
        <CheckCircle2 className="w-3.5 h-3.5" />{partial ? `שולם חלקית (${Math.round(ratio * 100)}%) בחשבון מרוכז` : 'שולם בחשבון מרוכז'}
      </Link>
    );
  }
  return (
    <div className="bg-green-600 text-white rounded-lg p-3 flex flex-wrap items-center gap-3 shadow-md" data-testid={testId}>
      <CheckCircle2 className="w-7 h-7 shrink-0" />
      <div className="flex-1 min-w-[160px]">
        <p className="font-black text-base">שולם בחשבון מרוכז</p>
        {note && <p className="text-xs text-green-100">{note}</p>}
      </div>
      <Link to={href} onClick={(e) => e.stopPropagation()} className="inline-flex items-center gap-1 bg-white text-green-700 font-bold text-sm px-3 py-1.5 rounded-md hover:bg-green-50" data-testid={`${testId}-link`}>
        <ExternalLink className="w-4 h-4" />פתח חשבון מרוכז
      </Link>
    </div>
  );
};
